module.exports = __webpack_public_path__ + "img/card3.4ec4b292.png";